var consts = require('content/consts');

var RecordContent = function RecordContentImpl(records) {
    this.length = records.length;

    this.get = function(i) {
        i = i || 0;
        return records[i];
    };

    this.records = function() {
        return records.concat([]);
    };

    this.forEach = function(iterator) {
        records.forEach(iterator);
    };

    this.toString = function() {
        return records.join(consts.RECORD_DELIMITER);
    };
};

RecordContent.Record = function RecordImpl(fields) {
    this.length = fields.length;

    this.get = function(i) {
        i = i || 0;
        return fields[i];
    };

    this.fields = function() {
        return fields.concat([]);
    };

    this.forEach = function(iterator) {
        fields.forEach(iterator);
    };

    this.toString = function() {
        return fields.join(consts.FIELD_DELIMITER);
    };
};

module.exports = RecordContent;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/content/record-content/record-content.js
// module id = 274
// module chunks = 1